import React, { useState, useEffect } from "react";
import "./RMSOccupancy.css";

const Top = ({ isOccupied }) => {
    const fillColor = isOccupied ? "#E78576" : "#73C787";
  return (
    <svg className="xl:w-[36px] xl:h-[36px] lg:w-[32px] lg:h-[32px] md:w-[32px] md:h-[32px] sm:w-[22px] sm:h-[22px]  w-[10px] h-[10px]" viewBox="0 0 395 415" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_330_10914" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="395" height="415">
    <path d="M394.871 0.130859V414.798H0.459577V0.130859L394.871 0.130859Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_330_10914)">
    <path d="M339.48 55.6576C343.027 50.3711 341.308 44.8242 334.392 39.9961C302.803 17.8919 267.319 6.6211 229.334 2.51172C218.871 1.3763 208.319 1.11589 197.814 0.464844C151.084 0.964844 106.985 10.6263 67.0636 35.9023C64.4334 37.5794 61.8448 39.3398 59.3657 41.2357C53.9229 45.3867 52.6834 50.6992 55.8813 55.569C59.2563 60.6628 64.6938 61.0117 71.0688 57.6159C86.449 49.4596 101.308 39.4909 117.647 34.1211C180.454 13.4076 242.564 15.6055 302.845 44.4336C309.939 47.8242 316.465 52.418 323.079 56.6992C330.105 61.2721 335.85 61.0326 339.48 55.6576ZM90.3865 61.9232C123.761 42.319 160.329 34.8815 198.616 35.0326C236.387 35.1628 272.475 42.6055 305.35 62.0951C324.517 73.4544 340.548 87.9649 349.163 109.152C363.433 144.199 377.491 179.355 391.803 214.382C395.741 223.975 396.09 233.309 392.715 243.1C388.454 255.564 384.626 268.163 380.6 280.715C368.699 317.652 356.907 354.616 344.834 391.491C338.48 410.85 318.965 419.772 301.126 411.96C285.683 405.173 278.392 388.835 283.814 371.777C298.038 327.027 312.506 282.366 326.819 237.658C327.668 235.007 328.954 231.741 328.126 229.439C324.428 219.126 320.032 209.033 315.814 198.652C309.959 202.09 304.652 205.225 298.584 208.793C309.527 140.152 260.642 90.7461 207.668 86.069C178.798 83.5013 152.866 91.293 131.001 110.413C101.459 136.283 91.0375 169.392 96.8917 208.923C90.6938 205.199 85.6 202.132 79.6625 198.564C76.0271 207.507 72.9177 216.059 69.1104 224.283C66.9125 229.001 67.0427 233.137 68.6104 237.986C82.7927 281.475 97.0427 324.965 110.511 368.689C112.793 376.09 113.23 384.965 111.532 392.47C108.553 405.824 95.7615 414.335 82.1209 414.548C67.3032 414.788 55.5375 406.611 50.7511 391.861C34.7615 342.626 19.1417 293.309 3.04275 244.121C-0.420794 233.527 -0.202045 223.736 4.06358 213.423C17.4646 181.121 31.1053 148.876 43.3292 116.116C52.3813 91.793 68.699 74.6471 90.3865 61.9232ZM197.465 97.5586C247.308 97.4492 288.225 138.241 288.293 188.079C288.314 237.553 247.72 278.449 198.293 278.71C148.496 278.996 107.334 238.267 107.136 188.538C106.923 138.741 147.735 97.6472 197.465 97.5586Z" fill={fillColor}/>
    </g>
    </svg>
    
  );
};

const Left = ({ isOccupied }) => {
    const fillColor = isOccupied ? "#E78576" : "#73C787";
    return (
      <svg className="xl:w-[36px] xl:h-[36px] lg:w-[32px] lg:h-[32px] md:w-[32px] md:h-[32px] sm:w-[22px] sm:h-[22px]  w-[10px] h-[10px]" viewBox="0 0 395 415" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_330_10914" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="415" height="395">
        <path d="M414.999 394.668L0.332246 394.668L0.332246 0.256405L414.999 0.256405L414.999 394.668Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_330_10914)">
        <path d="M359.473 339.277C364.759 342.824 370.306 341.105 375.134 334.189C397.238 302.6 408.509 267.116 412.619 229.131C413.754 218.668 414.014 208.116 414.666 197.61C414.166 150.881 404.504 106.782 379.228 66.8604C377.551 64.2302 375.791 61.6417 373.895 59.1625C369.744 53.7198 364.431 52.4802 359.561 55.6781C354.468 59.0531 354.119 64.4906 357.514 70.8656C365.671 86.2458 375.639 101.105 381.009 117.444C401.723 180.251 399.525 242.36 370.697 302.642C367.306 309.735 362.712 316.262 358.431 322.876C353.858 329.902 354.098 335.647 359.473 339.277ZM353.207 90.1833C372.811 123.558 380.249 160.126 380.098 198.413C379.968 236.183 372.525 272.272 353.035 305.147C341.676 324.314 327.166 340.345 305.978 348.959C270.931 363.23 235.775 377.288 200.749 391.6C191.155 395.538 181.822 395.887 172.03 392.512C159.566 388.251 146.968 384.423 134.415 380.397C97.4779 368.496 60.5144 356.704 23.6394 344.631C4.28 338.277 -4.64188 318.762 3.17063 300.923C9.95709 285.48 26.2956 278.189 43.3529 283.61C88.1029 297.834 132.764 312.303 177.473 326.616C180.124 327.465 183.389 328.751 185.692 327.923C196.004 324.225 206.098 319.829 216.478 315.61C213.04 309.756 209.905 304.449 206.337 298.381C274.978 309.324 324.384 260.439 329.061 207.465C331.629 178.595 323.837 152.663 304.718 130.798C278.848 101.256 245.738 90.8344 206.207 96.6885C209.931 90.4906 212.999 85.3969 216.567 79.4594C207.624 75.8239 199.072 72.7146 190.848 68.9073C186.129 66.7094 181.994 66.8396 177.145 68.4073C133.655 82.5896 90.1654 96.8396 46.4415 110.308C39.0404 112.59 30.1654 113.027 22.6602 111.329C9.30604 108.35 0.795624 95.5583 0.582083 81.9177C0.342499 67.1 8.51959 55.3344 23.2696 50.5479C72.504 34.5583 121.822 18.9385 171.009 2.83958C181.603 -0.623966 191.395 -0.405217 201.707 3.86041C234.009 17.2615 266.254 30.9021 299.014 43.126C323.337 52.1781 340.483 68.4958 353.207 90.1833ZM317.572 197.261C317.681 247.105 276.889 288.022 227.051 288.09C177.577 288.11 136.681 247.517 136.421 198.09C136.134 148.293 176.863 107.131 226.593 106.933C276.389 106.72 317.483 147.532 317.572 197.261Z" fill={fillColor}/>
        </g>
     </svg>
      
    );
  };

  const Right = ({ isOccupied }) => {
    const fillColor = isOccupied ? "#E78576" : "#73C787";
    return (
        <svg className="xl:w-[36px] xl:h-[36px] lg:w-[32px] lg:h-[32px] md:w-[32px] md:h-[32px] sm:w-[22px] sm:h-[22px]  w-[10px] h-[10px]" viewBox="0 0 415 395" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_330_10914" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="415" height="395">
        <path d="M0.333496 0.255859H415V394.667H0.333496V0.255859Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_330_10914)">
        <path d="M55.8597 55.6467C50.5732 52.0998 45.0264 53.8185 40.1982 60.7352C18.0941 92.3237 6.82324 127.808 2.71387 165.792C1.57845 176.256 1.31803 186.808 0.666992 197.313C1.16699 244.043 10.8285 288.141 36.1045 328.063C37.7816 330.694 39.542 333.282 41.4378 335.761C45.5889 341.204 50.9014 342.444 55.7712 339.246C60.8649 335.871 61.2139 330.433 57.818 324.058C49.6618 308.678 39.693 293.819 34.3232 277.48C13.6097 214.673 15.8076 152.563 44.6357 92.2821C48.0264 85.1883 52.6201 78.6623 56.9014 72.0477C61.4743 65.0217 61.2347 59.2769 55.8597 55.6467ZM62.1253 304.74C42.5212 271.365 35.0837 234.798 35.2347 196.511C35.3649 158.74 42.8076 122.652 62.2972 89.7769C73.6566 70.6102 88.167 54.579 109.354 45.9644C144.401 31.6935 179.558 17.6362 214.584 3.32374C224.177 -0.613759 233.511 -0.962716 243.302 2.41228C255.766 6.6727 268.365 10.5008 280.917 14.5269C317.855 26.4279 354.818 38.2196 391.693 50.2925C411.052 56.6467 419.974 76.1623 412.162 94.0008C405.375 109.444 389.037 116.735 371.98 111.313C327.23 97.0894 282.568 82.6206 237.86 68.3081C235.209 67.4592 231.943 66.1727 229.641 67.0008C219.328 70.6987 209.235 75.0946 198.854 79.3133C202.292 85.1675 205.427 90.4748 208.995 96.5425C140.354 85.5998 90.9482 134.485 86.2712 187.459C83.7035 216.329 91.4951 242.261 110.615 264.126C136.485 293.668 169.594 304.089 209.125 298.235C205.401 304.433 202.334 309.527 198.766 315.464C207.709 319.1 216.261 322.209 224.485 326.016C229.203 328.214 233.339 328.084 238.188 326.516C281.677 312.334 325.167 298.084 368.891 284.615C376.292 282.334 385.167 281.897 392.672 283.595C406.026 286.574 414.537 299.365 414.75 313.006C414.99 327.824 406.813 339.589 392.063 344.376C342.828 360.365 293.511 375.985 244.323 392.084C233.729 395.548 223.938 395.329 213.625 391.063C181.323 377.662 149.078 364.022 116.318 351.798C91.9951 342.746 74.8493 326.428 62.1253 304.74ZM97.7607 197.662C97.6514 147.819 138.443 106.902 188.282 106.834C237.756 106.813 278.651 147.407 278.912 196.834C279.198 246.631 238.469 287.793 188.74 287.99C138.943 288.204 97.8493 247.391 97.7607 197.662Z" fill={fillColor}/>
        </g>
        </svg>        
      
    );
  };

const TopMirror = ({ isOccupied }) => {
    const fillColor = isOccupied ? "#E78576" : "#73C787";
    return (
        <svg className="xl:w-[36px] xl:h-[36px] lg:w-[32px] lg:h-[32px] md:w-[32px] md:h-[32px] sm:w-[22px] sm:h-[22px]  w-[10px] h-[10px]"viewBox="0 0 415 395" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_330_10914" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="395" height="415">
        <path d="M0.460449 414.795L0.460449 0.128144L394.872 0.128144L394.872 414.795L0.460449 414.795Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_330_10914)">
        <path d="M55.8513 359.268C52.3044 364.555 54.0231 370.102 60.9398 374.93C92.5284 397.034 128.013 408.305 165.997 412.414C176.461 413.549 187.013 413.81 197.518 414.461C244.247 413.961 288.346 404.299 328.268 379.023C330.898 377.346 333.487 375.586 335.966 373.69C341.409 369.539 342.648 364.227 339.45 359.357C336.075 354.263 330.638 353.914 324.263 357.31C308.883 365.466 294.023 375.435 277.685 380.805C214.877 401.518 152.768 399.32 92.4867 370.492C85.3929 367.102 78.8669 362.508 72.2523 358.227C65.2263 353.654 59.4815 353.893 55.8513 359.268ZM304.945 353.003C271.57 372.607 235.002 380.044 196.716 379.893C158.945 379.763 122.856 372.32 89.9815 352.831C70.8148 341.471 54.7836 326.961 46.169 305.773C31.8981 270.727 17.8408 235.57 3.52833 200.544C-0.409169 190.95 -0.758126 181.617 2.61687 171.825C6.87729 159.362 10.7054 146.763 14.7315 134.211C26.6325 97.2734 38.4242 60.3098 50.4971 23.4348C56.8513 4.07541 76.3669 -4.84647 94.2054 2.96604C109.648 9.7525 116.94 26.091 111.518 43.1483C97.294 87.8983 82.8252 132.56 68.5127 177.268C67.6638 179.919 66.3773 183.185 67.2054 185.487C70.9034 195.799 75.2992 205.893 79.5179 216.273C85.3721 212.836 90.6794 209.7 96.7471 206.133C85.8044 274.773 134.69 324.18 187.664 328.857C216.534 331.424 242.466 323.633 264.33 304.513C293.872 278.643 304.294 245.534 298.44 206.003C304.638 209.727 309.732 212.794 315.669 216.362C319.304 207.419 322.414 198.867 326.221 190.643C328.419 185.924 328.289 181.789 326.721 176.94C312.539 133.45 298.289 89.9609 284.82 46.2369C282.539 38.8358 282.101 29.9608 283.799 22.4556C286.778 9.10145 299.57 0.591034 313.211 0.377493C328.028 0.137909 339.794 8.315 344.58 23.065C360.57 72.2994 376.19 121.617 392.289 170.805C395.752 181.398 395.534 191.19 391.268 201.503C377.867 233.805 364.226 266.049 352.002 298.81C342.95 323.133 326.633 340.279 304.945 353.003ZM197.867 317.367C148.023 317.477 107.106 276.685 107.039 226.846C107.018 177.372 147.612 136.476 197.039 136.216C246.836 135.93 287.997 176.659 288.195 226.388C288.409 276.185 247.596 317.279 197.867 317.367Z" fill={fillColor}/>
        </g>
        </svg>
        
    );
  };

  const RMSOccupancy = ({ setCurrentCount }) => {
    const [rmsData, setRmsData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
    const fetchData = async () => {
      try {
        const response = await fetch("https://optimusb.flowfuse.cloud/HKU_live");
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();

      // Process RMS data
      const formattedRmsData = {};
      let count = 0;
        Object.keys(data[0]).forEach((key) => {
        if (key.startsWith("RMS-D")) {
            const isOccupied = data[0][key].occupancy === 1;
          formattedRmsData[key] = isOccupied;
          if (isOccupied) count++;
        }
      });

      setRmsData(formattedRmsData);
      setCurrentCount(count); // Update parent component with occupied count
        setError(null);
    } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
    }
  };

    useEffect(() => {
      fetchData(); // Fetch data initially
      const interval = setInterval(fetchData, 10000); // Poll every 10 seconds
      return () => clearInterval(interval); 
    }, []);
  
    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;
  return (
    <div className="relative">

    <div className="left">
        <div className="absolute flex xl:top-[100px] xl:left-8 lg:top-[82px] lg:left-7 md:top-[82px] md:left-6 sm:top-[62px] sm:left-6 top-[38px] left-3 gap-4 xl:gap-10 lg:gap-8 sm:gap-5 md:gap-7 ">
            <div className="tooltip">
                <Top isOccupied={rmsData["RMS-D24"]} />
                <span className="tooltip-text">RMS-D24</span>
           </div>
           <div className="tooltip">
                <Top isOccupied={rmsData["RMS-D25"]} />
                <span className="tooltip-text">RMS-D25</span>
            </div>
        </div>

        <div className="absolute flex xl:top-[164px] xl:left-8 xl:gap-10 lg:top-[136px] lg:left-7 md:top-[128px] md:left-6 sm:top-[102px] sm:left-6 sm:gap-5 top-[60px] left-3 gap-4 lg:gap-8 md:gap-7">
            <div className="tooltip">
                <TopMirror isOccupied={rmsData["RMS-D23"]} />
                <span className="tooltip-text">RMS-D23</span>
            </div>
            <div className="tooltip">
                <TopMirror  isOccupied={rmsData["RMS-D22"]} />
                <span className="tooltip-text">RMS-D22</span>
            </div>
        </div>

        <div className="absolute flex xl:top-[290px] xl:left-8 lg:top-[240px] lg:left-7 md:left-6 md:top-[232px] sm:top-[182px] sm:left-6 top-[108px] left-3 gap-4 xl:gap-10 lg:gap-8 sm:gap-5 md:gap-7">
        <div className="tooltip">
                <Top isOccupied={rmsData["RMS-D29"]} />
                <span className="tooltip-text">RMS-D29</span>
            </div>
            <div className="tooltip">
                <Top isOccupied={rmsData["RMS-D30"]} />
                <span className="tooltip-text">RMS-D30</span>
            </div>
        </div>

        <div className="absolute flex xl:top-[354px] xl:left-8 xl:gap-10 lg:top-[296px] lg:left-7 md:left-6 md:top-[280px] sm:top-[220px]  sm:left-6 top-[130px] left-3 gap-4 lg:gap-8 sm:gap-5 md:gap-7">
        <div className="tooltip">
                <TopMirror  isOccupied={rmsData["RMS-D28"]} />
                <span className="tooltip-text">RMS-D28</span>
            </div>
            <div className="tooltip">
                <TopMirror  isOccupied={rmsData["RMS-D27"]} />
                <span className="tooltip-text">RMS-D27</span>
            </div>
        </div>
        <div className="absolute flex xl:top-[134px] xl:left-[162px] xl:gap-10 lg:top-[111px] lg:left-[133px]  md:top-[108px] md:left-[128px] sm:top-[82px]  sm:left-[101px] top-[50px] left-[60px]  lg:gap-8 md:gap-7">
        <div className="tooltip">
            <Left  isOccupied={rmsData["RMS-D21"]} />
            <span className="tooltip-text">RMS-D21</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[326px] xl:left-[162px] xl:gap-10 lg:top-[270px] lg:left-[133px]  md:top-[260px]  md:left-[128px]  sm:top-[202px]  sm:left-[101px] top-[120px] left-[60px] lg:gap-8 md:gap-7">
            <div className="tooltip">
            <Left  isOccupied={rmsData["RMS-D26"]} />
            <span className="tooltip-text">RMS-D26</span>
        </div>
        </div>

    </div> 
    {/* --left-- */}

    <div className="mid-1">
        <div className="absolute flex xl:top-[40px] xl:left-[476px] xl:gap-10 lg:top-[30px] lg:left-[394px] md:top-[28px] md:left-[382px] sm:top-[24px] sm:left-[296px] top-[16px] left-[174px] md:gap-6 lg:gap-8">
        <div className="tooltip">
            <Left  isOccupied={rmsData["RMS-D13"]} />
            <span className="tooltip-text">RMS-D13</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[110px] xl:left-[476px] xl:gap-10 lg:top-[90px] lg:left-[394px] md:top-[88px] md:left-[382px] sm:top-[66px] sm:left-[296px] top-[40px] left-[174px]  md:gap-6 lg:gap-8">
        <div className="tooltip">
            <Left  isOccupied={rmsData["RMS-D14"]} />
            <span className="tooltip-text">RMS-D14</span>
        </div>
        </div>

        <div className="absolute flex xl:top-[236px] xl:left-[476px] xl:gap-10 lg:top-[196px] lg:left-[394px] md:top-[186px] md:left-[382px] sm:top-[146px] sm:left-[296px] top-[86px] left-[174px] lg:gap-8">
        <div className="tooltip">
            <Left  isOccupied={rmsData["RMS-D15"]} />
            <span className="tooltip-text">RMS-D15</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[306px] xl:left-[476px] xl:gap-10 lg:top-[260px] lg:left-[394px] md:top-[250px] md:left-[382px] sm:top-[192px] sm:left-[296px] top-[112px] left-[174px] lg:gap-8">
        <div className="tooltip">
            <Left  isOccupied={rmsData["RMS-D16"]} />
            <span className="tooltip-text">RMS-D16</span>
        </div>
        </div>

        <div className="absolute flex xl:top-[40px] xl:left-[416px] xl:gap-10 lg:top-[30px] lg:left-[344px] md:top-[28px] md:left-[332px] sm:top-[24px] sm:left-[260px] top-[16px] left-[152px]  lg:gap-8">
        <div className="tooltip">
            <Right  isOccupied={rmsData["RMS-D17"]} />
            <span className="tooltip-text">RMS-D17</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[110px] xl:left-[416px] xl:gap-10 lg:top-[90px] lg:left-[344px] md:top-[88px] md:left-[332px] sm:top-[66px] sm:left-[260px] top-[40px] left-[152px] lg:gap-8">
        <div className="tooltip">
            <Right  isOccupied={rmsData["RMS-D18"]} />
            <span className="tooltip-text">RMS-D18</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[236px] xl:left-[416px] xl:gap-10 lg:top-[196px] lg:left-[344px] md:top-[186px] md:left-[332px] sm:top-[146px] sm:left-[260px] top-[86px] left-[152px] lg:gap-8">
        <div className="tooltip">
            <Right  isOccupied={rmsData["RMS-D19"]} />
            <span className="tooltip-text">RMS-D19</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[306px] xl:left-[416px] xl:gap-10 lg:top-[260px] lg:left-[344px] md:top-[250px] md:left-[332px] sm:top-[192px] sm:left-[260px] top-[112px] left-[152px] lg:gap-8">
        <div className="tooltip">
            <Right  isOccupied={rmsData["RMS-D20"]} />
            <span className="tooltip-text">RMS-D20</span>
        </div>
        </div>


    </div>

    <div className="mid-2">
        <div className="absolute flex xl:top-[40px] xl:left-[648px] xl:gap-10 lg:top-[30px] lg:left-[538px] md:top-[28px] md:left-[520px] sm:top-[24px] sm:left-[404px] top-[16px] left-[236px] lg:gap-8">
        <div className="tooltip">
            <Left  isOccupied={rmsData["RMS-D05"]} />
            <span className="tooltip-text">RMS-D05</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[110px] xl:left-[648px] xl:gap-10 lg:top-[90px] lg:left-[538px] md:top-[88px] md:left-[520px] sm:top-[66px] sm:left-[404px] top-[40px] left-[236px] lg:gap-8">
        <div className="tooltip">
            <Left  isOccupied={rmsData["RMS-D06"]} />
            <span className="tooltip-text">RMS-D06</span>
        </div>
        </div>

        <div className="absolute flex xl:top-[236px] xl:left-[648px] xl:gap-10 lg:top-[196px] lg:left-[538px] md:top-[186px] md:left-[520px] sm:top-[146px] sm:left-[404px] top-[86px] left-[236px] lg:gap-8">
        <div className="tooltip">
            <Left  isOccupied={rmsData["RMS-D07"]} />
            <span className="tooltip-text">RMS-D07</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[306px] xl:left-[648px] xl:gap-10 lg:top-[260px] lg:left-[538px] md:top-[250px] md:left-[520px] sm:top-[192px] sm:left-[404px] top-[112px] left-[236px] lg:gap-8">
        <div className="tooltip">
            <Left  isOccupied={rmsData["RMS-D08"]} />
            <span className="tooltip-text">RMS-D08</span>
        </div>
        </div>

        <div className="absolute flex xl:top-[40px] xl:left-[590px] xl:gap-10 lg:top-[30px] lg:left-[486px] md:top-[28px] md:left-[470px] sm:top-[24px] sm:left-[366px] top-[16px] left-[214px] lg:gap-8">
        <div className="tooltip">
            <Right  isOccupied={rmsData["RMS-D09"]} />
            <span className="tooltip-text">RMS-D09</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[110px] xl:left-[590px] xl:gap-10 lg:top-[90px] lg:left-[486px] md:top-[88px] md:left-[470px] sm:top-[66px] sm:left-[366px] top-[40px] left-[214px] lg:gap-8">
        <div className="tooltip">
            <Right  isOccupied={rmsData["RMS-D10"]} />
            <span className="tooltip-text">RMS-D10</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[236px] xl:left-[590px] xl:gap-10 lg:top-[196px] lg:left-[486px] md:top-[186px] md:left-[470px] sm:top-[146px] sm:left-[366px] top-[86px] left-[214px] lg:gap-8">
        <div className="tooltip">
            <Right  isOccupied={rmsData["RMS-D11"]} />
            <span className="tooltip-text">RMS-D11</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[306px] xl:left-[590px] xl:gap-10 lg:top-[260px] lg:left-[486px] md:top-[250px] md:left-[470px] sm:top-[192px] sm:left-[366px] top-[112px] left-[214px] lg:gap-8">
        <div className="tooltip">
            <Right  isOccupied={rmsData["RMS-D12"]} />
            <span className="tooltip-text">RMS-D12</span>
        </div>
        </div>

    </div>

    {/* --mid-- */}

    <div className="right">
    <div className="absolute flex xl:top-[40px] xl:left-[880px] xl:gap-10 lg:top-[30px] lg:left-[722px] md:top-[28px] md:left-[700px] sm:top-[24px] sm:left-[544px] top-[16px] left-[318px] lg:gap-8">
    <div className="tooltip">
            <Right  isOccupied={rmsData["RMS-D01"]} />
            <span className="tooltip-text">RMS-D01</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[110px] xl:left-[880px] xl:gap-10 lg:top-[90px] lg:left-[722px] md:top-[88px] md:left-[700px] sm:top-[66px] sm:left-[544px] top-[40px] left-[318px] lg:gap-8">
        <div className="tooltip">
            <Right  isOccupied={rmsData["RMS-D02"]} />
            <span className="tooltip-text">RMS-D02</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[236px] xl:left-[882px] xl:gap-10 lg:top-[196px] lg:left-[726px] md:top-[184px] md:left-[700px] sm:top-[146px] sm:left-[544px] top-[86px] left-[318px] lg:gap-8">
        <div className="tooltip">
            <Right  isOccupied={rmsData["RMS-D03"]} />
            <span className="tooltip-text">RMS-D03</span>
        </div>
        </div>
        <div className="absolute flex xl:top-[306px] xl:left-[882px] xl:gap-10 lg:top-[260px] lg:left-[726px] md:top-[248px] md:left-[700px] sm:top-[192px] sm:left-[544px] top-[112px] left-[318px] lg:gap-8">
            <div className="tooltip">
            <Right  isOccupied={rmsData["RMS-D04"]} />
            <span className="tooltip-text">RMS-D04</span>
        </div>
        </div>

    </div>
        

    </div>
  );
};

export default RMSOccupancy;
